/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ISubscriptionPayment } from 'app/shared/model/subscription-payment.model';
import { IContactDetails } from 'app/shared/model/contact-details.model';

export interface ISubscriptionBilling {
  id?: string;
  firstName?: string;
  lastName?: string;
  customerId?: string | null;
  validTill?: number;
  remindFrom?: number;
  lockOutOn?: number;
  active?: boolean;
  lastupdated?: number;
  microSec?: number;
  timestampentry?: number;
  cursor?: number;
  payment?: ISubscriptionPayment;
  contactDetails?: IContactDetails;
}

export const defaultValue: Readonly<ISubscriptionBilling> = {
  active: false,
};
